import React, { useState } from 'react'
import { element, string, any } from 'prop-types'
import { Button } from 'syngenta-react-components'
import Alert from '../../../components/subComponents/Notifications/Alert'
import ModalWithStates from '../../../dpe-usco/components/ModalWithStates/ModalWithStates'
import { patchDeleteScaleTicket } from '../../../services/apiHelper'

const Widget = ({ title, subTitle, children, button, dataTestId, buttonDataTestId, totalSelectedRow, productionPlanId }) => {
  const [showModal, setshowModal] = useState(false)
  const [showAlert, setShowAlert] = useState(false)


  const deleteContracts = () => {
    if (totalSelectedRow.length === 0) {
      setShowAlert(true)
    } else {
      setshowModal(true)
    }
  }
  const handleClose = () => {
    setshowModal(false)
  }

  const deleteScaleTicket = async scaleVal => {
    const list = scaleVal.map(data => {
      return {
        'production_plan_id': productionPlanId,
        'scale_ticket_id': data.rowContent.scale_ticket_id
      }
    })
    const sendList = { 'scale_tickets': list }
    let response = await patchDeleteScaleTicket(sendList)
    if (response.status === 200) {
      window.location.reload()
    } else {
      //setStatus('ERROR')
    }
  }

  let bottomRow = (
    <>
      <Button onClick={handleClose}>Cancel</Button>
      <div>
        <Button
          styleType="error"
          onClick={() => deleteScaleTicket(totalSelectedRow)}
          customClassName="ml10 mr10"
        >
          Delete
        </Button>
      </div>
    </>
  )
  return (
    <>
      {totalSelectedRow?.length || totalSelectedRow?.length === 0 ?
        <div data-testid={dataTestId} className='bd1-s-lightgray pb15 mt25 pl25 bdrs-4 pr25 tal'>
          <ModalWithStates
            handleClose={handleClose}
            showModal={showModal}
            content={'You’re about to permanently delete ' + totalSelectedRow.length + ' scale tickets, reverting the Net Bushels on the scale ticket back to the appropriate inventories.'}
            title='Delete scale ticket?'
            bottomRow={bottomRow}
          />
          {showAlert ? (
            <Alert
              alertMessage='Please select at least one row to Delete a Scale Ticket.'
              handleDismiss={() => setShowAlert(false)}
            />
          ) : null}
          <div data-testid={buttonDataTestId} className='df jcsb mt15 mb15 fw600'>
            <div>
              {title}
              {totalSelectedRow.length > 0 && (
                <span className='c-darkgray pl25'>{' ' + totalSelectedRow.length + ' Selected'}</span>
              )}
              {
                subTitle && (
                  <span style={{ fontSize: 'smaller' }} className='c-darkgray pl25'>{subTitle}</span>
                )
              }
            </div>
            <div className='df jcsb'>
              {button}
              <div>
                <Button onClick={deleteContracts} styleType="error" customClassName="ml10">
                  Delete
                </Button>
              </div>
            </div>
          </div>
          {children}
        </div> :
        <div data-testid={dataTestId} className='bd1-s-lightgray pb15 mt25 pl25 bdrs-4 pr25 tal'>
          <div data-testid={buttonDataTestId} className='df jcsb mt15 mb15 fw600'>
            <div>
              {title}
              {
                subTitle && (
                  <span style={{ fontSize: 'smaller' }} className='c-darkgray pl25 fsi'>{subTitle}</span>
                )
              }
            </div>
            {button}</div>
          {children}
        </div>}
    </>
  )
}

export default Widget

Widget.propTypes = {
  title: string,
  subTitle: string,
  children: any,
  button: element
}